package ru.notamedia.qah.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import qualityassurancehelper.composeapp.generated.resources.Res
import qualityassurancehelper.composeapp.generated.resources.back_arrow
import ru.notamedia.qah.NavController

@Composable
fun HeaderScreen(
    navController: NavController,
    title: String,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(16.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp),
    ) {
        Box(
            modifier = Modifier.clickable(
                onClick = { navController.back() },
            )
        ) {
            Icon(
                painter = painterResource(Res.drawable.back_arrow),
                contentDescription = "Назад",
            )
        }

        Text(
            text = title,
            style = MaterialTheme.typography.titleMedium,
        )
    }
}
